module.exports = __webpack_public_path__ + "img/set_theme_16.c19df444.png";